export default __webpack_public_path__ + "static/media/25-EXT-(3-4).ced0ed1e.jpg";